/* eslint-disable no-extend-native */
// Number only extension
export {};
declare global {
    interface Number {
        pad(digits: number): string;
    }
}

if (!Number.prototype.pad) {
    Number.prototype.pad = function pad(this: Number, digits: number): string {
        let result = `${this}`;
        while (result.length < digits) result = `0${result}`;
        return result;
    };
}

export {};
declare global {
    interface Number {
        format(format: string): string;
    }
}

if (!Number.prototype.format) {
    Number.prototype.format = function format(
        this: Number,
        format: string
    ): string {
        let result = "";
        let index = 0;
        let string = `${this}`;
        let decimal = string.indexOf(".");
        let subString = string.substring(
            0,
            decimal === -1 ? string.length : decimal
        );
        let subString2 =
            decimal === -1 ? "" : string.substring(decimal + 1, string.length);
        decimal = format.indexOf(".");
        decimal = decimal === -1 ? format.length : decimal;
        let subString3 = subString.length - 1;

        for (index = decimal - 1; index >= 0; index--) {
            var current = format[index];
            switch (current) {
                case "#":
                    result =
                        (subString3 >= 0 && subString.length > subString3
                            ? subString[subString3]
                            : "") + result;
                    subString3--;
                    break;
                case "0":
                    result =
                        (subString3 >= 0 && subString.length > subString3
                            ? subString[subString3]
                            : "0") +
                        (format[index + 1] === "," && subString3 === -1
                            ? ","
                            : "") +
                        result;
                    subString3--;
                    break;
                case ",":
                    result = (subString3 >= 0 ? current : "") + result;
                    break;
                default:
                    result = current + result;
            }
        }

        if (format.indexOf(".") >= 0) result = result + ".";

        for (index = decimal + 1; index < format.length; index++) {
            current = format[index];
            subString3 = index - decimal - 1;
            switch (current) {
                case "#":
                    result =
                        result +
                        (subString2.length > subString3
                            ? subString2[subString3]
                            : "");
                    break;
                case "0":
                    result =
                        result +
                        (subString2.length > subString3
                            ? subString2[subString3]
                            : "0");
                    break;
                default:
                    result = result + current;
            }
        }

        if (result.indexOf(".") === result.length - 1)
            result = result.substring(0, result.length - 1);

        return result;
    };
}
